const pattern = /^(?:\+?1)?[-.●\s]?\(?([2-9]{1}\d{0,2})?\)?[-.●\s]?(\d{1,3})?[-.●\s]?(\d{1,4})?$/;

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
const validator = (value: string, setValue: Function): void => {
  const match = value.match(pattern);
  if (match) {
    let newValue = '';
    const capturedGroups = match.slice(1).filter((x) => x);
    if (capturedGroups[0]) newValue += capturedGroups[0];
    if (capturedGroups[1]?.length) newValue += '-';
    if (capturedGroups[1]) newValue += capturedGroups[1];
    if (capturedGroups[2]?.length) newValue += '-';
    if (capturedGroups[2]) newValue += capturedGroups[2];
    setValue(newValue);
  }
};

export default validator;
